import {
  all, takeEvery, fork, call, put, takeLatest,
} from 'redux-saga/effects';
import api from 'services';
import _ from 'lodash';
import actions from './actions';

const entityType = 'bearerTokens';

export function* fetchBearerTokensSaga() {
  yield takeEvery(actions.FETCH_BEARERTOKENS, function* () {
    const res = yield call(api.fetchAll, { entityType });
    const data = _.get(res, 'keys', []);
    if (res && data && !('err' in data)) {
      yield put({ type: actions.FETCH_BEARERTOKENS_SUCCESS, data });
    } else {
      yield put({ type: actions.FETCH_BEARERTOKENS_FAILURE });
    }
  });
}

export function* addBearerToken() {
  yield takeEvery(actions.ADD_BEARERTOKEN, function* (action) {
    const { tokenType } = action;
    const bearerToken = yield call(api.createItem, { entityType, data: tokenType === 'read-only' ? { scope: 'media:read' } : { }, disableNotification: true });
    
    if (bearerToken) {
      yield put({ type: actions.ADD_BEARERTOKEN_SUCCESS, newBearerToken: bearerToken });
      yield put({ type: actions.FETCH_BEARERTOKENS });
    } else {
      yield put({ type: actions.ADD_BEARERTOKEN_FAILURE });
    }
  });
}

export function* clearNewBearerToken() {
  yield takeLatest(actions.CLEAR_NEW_BEARERTOKEN, function* () {
    yield put({ type: actions.CLEAR_NEW_BEARERTOKEN_SUCCESS });
  });
}

export function* deleteBearerToken() {
  yield takeEvery(actions.DELETE__BEARERTOKEN, function* () {
  });
}

export default function* rootSaga() {
  yield all([
    fork(fetchBearerTokensSaga),
    fork(addBearerToken),
    fork(deleteBearerToken),
    fork(clearNewBearerToken),
  ]);
}
